// Der Name der Website fuer den Dokumenttitel. WordPress liefert ihn per
// wp_localize_script (get_bloginfo('name')): als matrixPublicParams in den
// oeffentlichen Apps, als matrixParams im MatchMeista-Shortcode — auf einer
// Messe-Seite mit MatchMeista stehen beide. Ohne beide (Harness ohne Angabe)
// bleibt er leer, und der Seitentitel steht allein.
const aus = (params) => (params && params.site_name) || ''

export const siteName = () => aus(window.matrixPublicParams) || aus(window.matrixParams)
